import './index.scss';
import React from 'react';
const Result = ({ result, selectedResults, setSelectedResults }) => {
    const handleSelectResult = () => {
        const hasResult = selectedResults.indexOf(result);
        if (hasResult > -1) {
            const newResults = [...selectedResults];
            newResults.splice(hasResult, 1);
            setSelectedResults(newResults);
            return;
        }
        setSelectedResults([...selectedResults, result]);
    };
    return React.createElement("div", { className: 'classification-result', onClick: handleSelectResult },
        React.createElement("div", { className: 'check-container' }, selectedResults.includes(result) && React.createElement("span", null,
            React.createElement("i", { className: 'far fa-check' }),
            " ")),
        React.createElement("div", { key: `result-${result}`, className: 'classification-results-item overflow-ellipsis', title: result }, result));
};
export default Result;
